import axios from 'axios'
import keycloak from '../Components/keycloak'

const axiosApiInstance = axios.create()
let access_token = ''
let newurl

const determineURL = () => {
    // const location = window.location.hostname
    const baseUrl = `/api/bcrms`
    // const baseUrl = `https://${location}/api/bcrms`
    // if (location === 'localhost') {
    //     return 'http://localhost:5519'
    //     // return 'https://berkadia360qc.berkadia.com'
    // }

    return baseUrl
}

axiosApiInstance.defaults.baseURL = determineURL()
axiosApiInstance.defaults.responseType = "json"

function getBaseUrl() {
    let retuenVal = '/api/bcrms'
    if (newurl.includes('/api/emaillist')) {
        retuenVal = ''
    }
    if (newurl.includes('/excelprocessor/CompReport/Download')) {
        retuenVal = '/api'
    }

    return retuenVal
}

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
    async config => {
        // const access_token = await refreshToken()
        // console.log('access_token::', access_token)
        config.headers = {
            'Authorization': `Bearer ${keycloak.token}`,
            'Content-Type': 'application/json'
        }
        config.baseURL = await getBaseUrl()
        return config
    },
    error => {
        Promise.reject(error)
    })

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
    return response
}, async function (error) {
    throw error
    // console.log(error)
})

async function API(url, payload, method = 'post') {
    newurl = url
    // access_token = token
    //  method = method.toLowerCase()
    if (url.includes('getContactsCSV')) {
        axiosApiInstance.defaults.responseType = 'application/octet-stream'
    }

    switch (method) {
        case 'get':
            return await axiosApiInstance.get(url)
        case 'delete':
            return await axiosApiInstance.delete(url, { data: payload })
        default:
            return await axiosApiInstance.post(url, payload)
    }
    // return await axiosApiInstance.post(url, payload)
}

export default API
